export default __webpack_public_path__ + "static/media/M18.4cc7ea59.svg";